import { createRoot } from 'react-dom/client'

import 'init'

import App from './App'

const container = document.getElementById('root')!
const root = createRoot(container)
root.render(<App />)
